<template>
    <div class="portlet light">
        <div class="portlet-body">
            <wes-message v-bind="getMessagePanel()"></wes-message>

            <slot name="filtro"></slot>

            <div v-if="(this.showCheckBox && this.data && this.data.length > 0)">
                Mostrar:&nbsp;&nbsp;
                <label class="mt-checkbox"
                    v-for="(item, index) in this.fields.filter(item => item.groupIndex >= 0 && item.groupName !== 'Date')"
                    :key="index">
                    {{ item.caption + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" }}
                    <input type="checkbox" @click="checkClick(item)" v-model="item.visible">
                    <span></span>
                </label>
            </div>
            <div id="pivotgrid"></div>

            <div v-if="exportDialog.visible" class="modal fade in balancete-export-dialog" tabindex="-1" role="dialog" style="display:block;">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" v-on:click="cancelarExportacaoExcel">&times;</button>
                            <h4 class="modal-title">Parâmetros para impressão</h4>
                        </div>
                        <div class="modal-body">
                            <ul class="nav nav-tabs balancete-export-tabs">
                                <li v-bind:class="{ active: exportDialog.abaAtiva === 'formatacao' }">
                                    <a href="javascript:void(0)" v-on:click="exportDialog.abaAtiva = 'formatacao'">Formatação</a>
                                </li>
                                <li v-bind:class="{ active: exportDialog.abaAtiva === 'assinaturas' }">
                                    <a href="javascript:void(0)" v-on:click="exportDialog.abaAtiva = 'assinaturas'">Assinaturas</a>
                                </li>
                                <li v-bind:class="{ active: exportDialog.abaAtiva === 'arquivo' }">
                                    <a href="javascript:void(0)" v-on:click="exportDialog.abaAtiva = 'arquivo'">Arquivo</a>
                                </li>
                            </ul>
                            <div v-show="exportDialog.abaAtiva === 'formatacao'" class="row balancete-export-tab-content">
                                <div class="col-md-6">
                                    <fieldset>
                                        <legend>Cabeçalho</legend>
                                        <div class="form-group">
                                            <label>Esquerda:</label>
                                            <input type="text" class="form-control" v-model="exportDialog.parametros.CabecalhoEsquerda">
                                        </div>
                                        <div class="form-group">
                                            <label>Centro:</label>
                                            <input type="text" class="form-control" v-model="exportDialog.parametros.CabecalhoCentro">
                                        </div>
                                        <div class="form-group">
                                            <label>Direita:</label>
                                            <input type="text" class="form-control" v-model="exportDialog.parametros.CabecalhoDireita">
                                        </div>
                                    </fieldset>
                                    <fieldset>
                                        <legend>Rodapé</legend>
                                        <div class="form-group">
                                            <label>Esquerda:</label>
                                            <input type="text" class="form-control" v-model="exportDialog.parametros.RodapeEsquerda">
                                        </div>
                                        <div class="form-group">
                                            <label>Centro:</label>
                                            <input type="text" class="form-control" v-model="exportDialog.parametros.RodapeCentro">
                                        </div>
                                        <div class="form-group">
                                            <label>Direita:</label>
                                            <input type="text" class="form-control" v-model="exportDialog.parametros.RodapeDireita">
                                        </div>
                                    </fieldset>
                                </div>
                                <div class="col-md-6">
                                    <fieldset>
                                        <legend>Centralizar na página</legend>
                                        <label class="checkbox-inline">
                                            <input type="checkbox" v-model="exportDialog.parametros.CentralizarHorizontalmente">
                                            Horizontalmente
                                        </label>
                                        <label class="checkbox-inline">
                                            <input type="checkbox" v-model="exportDialog.parametros.CentralizarVerticalmente">
                                            Verticalmente
                                        </label>
                                    </fieldset>
                                    <fieldset>
                                        <legend>Margens (polegadas)</legend>
                                        <div class="row">
                                            <div class="col-xs-6 form-group">
                                                <label>Esquerda:</label>
                                                <input type="number" step="0.1" class="form-control" v-model.number="exportDialog.parametros.MargemEsquerda">
                                            </div>
                                            <div class="col-xs-6 form-group">
                                                <label>Topo:</label>
                                                <input type="number" step="0.1" class="form-control" v-model.number="exportDialog.parametros.MargemTopo">
                                            </div>
                                            <div class="col-xs-6 form-group">
                                                <label>Direita:</label>
                                                <input type="number" step="0.1" class="form-control" v-model.number="exportDialog.parametros.MargemDireita">
                                            </div>
                                            <div class="col-xs-6 form-group">
                                                <label>Fundo:</label>
                                                <input type="number" step="0.1" class="form-control" v-model.number="exportDialog.parametros.MargemFundo">
                                            </div>
                                        </div>
                                    </fieldset>
                                    <fieldset>
                                        <legend>Reduzir para</legend>
                                        <div class="row">
                                            <div class="col-xs-6 form-group">
                                                <input type="number" min="-1" class="form-control" v-model.number="exportDialog.parametros.ReduzirPaginasHorizontais">
                                                <span>páginas horizontais</span>
                                            </div>
                                            <div class="col-xs-6 form-group">
                                                <input type="number" min="-1" class="form-control" v-model.number="exportDialog.parametros.ReduzirPaginasVerticais">
                                                <span>páginas verticais</span>
                                            </div>
                                        </div>
                                    </fieldset>
                                    <fieldset class="balancete-export-options">
                                        <label class="checkbox-inline">
                                            <input type="checkbox" v-model="exportDialog.parametros.DaEsquerdaParaDireita">
                                            da esquerda p/direita
                                        </label>
                                        <label class="checkbox-inline">
                                            <input type="checkbox" v-model="exportDialog.parametros.IgnorarCores">
                                            Ignorar cores
                                        </label>
                                        <label class="checkbox-inline">
                                            <input type="checkbox" v-model="exportDialog.parametros.LinhasDeGrade">
                                            Linhas de grade
                                        </label>
                                        <label class="checkbox-inline">
                                            <input type="checkbox" v-model="exportDialog.parametros.Paisagem">
                                            Paisagem
                                        </label>
                                    </fieldset>
                                </div>
                            </div>
                            <div v-show="exportDialog.abaAtiva === 'assinaturas'" class="balancete-export-tab-content">
                                <fieldset>
                                    <legend>Cabeçalhos adicionais</legend>
                                    <textarea class="form-control" rows="4" v-model="exportDialog.parametros.CabecalhoAdicional"></textarea>
                                </fieldset>
                                <fieldset>
                                    <legend>Assinaturas da esquerda</legend>
                                    <textarea class="form-control" rows="4" v-model="exportDialog.parametros.AssinaturaEsquerda"></textarea>
                                </fieldset>
                                <fieldset>
                                    <legend>Assinaturas da direita</legend>
                                    <textarea class="form-control" rows="4" v-model="exportDialog.parametros.AssinaturaDireita"></textarea>
                                </fieldset>
                                <fieldset>
                                    <legend>Espaçamento das assinaturas</legend>
                                    <div class="form-group">
                                        <label>Quantidade de linhas entre o final da planilha e as assinaturas:</label>
                                        <input type="number" min="0" class="form-control" v-model.number="exportDialog.parametros.EspacamentoAssinaturas">
                                    </div>
                                </fieldset>
                            </div>
                            <div v-show="exportDialog.abaAtiva === 'arquivo'" class="balancete-export-tab-content">
                                <fieldset>
                                    <legend>Formato</legend>
                                    <label class="radio-inline">
                                        <input type="radio" value="XLSX" v-model="exportDialog.parametros.FormatoSaida" v-on:change="alterarFormatoSaida('XLSX')">
                                        Excel
                                    </label>
                                    <label class="radio-inline">
                                        <input type="radio" value="PDF" v-model="exportDialog.parametros.FormatoSaida" v-on:change="alterarFormatoSaida('PDF')">
                                        PDF
                                    </label>
                                </fieldset>
                                <fieldset>
                                    <legend>Nome do arquivo</legend>
                                    <label>Expressão:</label>
                                    <input type="text" class="form-control" v-model="exportDialog.parametros.ExpressaoNomeArquivo">
                                    <div class="btn-group" style="margin-top:10px;">
                                        <button type="button" class="btn default" v-on:click="inserirTokenNomeArquivo('{EMPRESA}')">Empresa</button>
                                        <button type="button" class="btn default" v-on:click="inserirTokenNomeArquivo('{PERIODO}')">Período</button>
                                        <button type="button" class="btn default" v-on:click="inserirTokenNomeArquivo('{PERFIL_BALANCETE}')">Perfil balancete</button>
                                    </div>
                                    <p class="help-block" style="margin-top:12px;"><strong>Nome final:</strong> {{ nomeArquivoBalancetePreview }}</p>
                                </fieldset>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn default pull-left" v-on:click="definirParametrosExportacaoPadrao">Padrão</button>
                            <button type="button" class="btn blue" v-on:click="confirmarExportacaoExcel">OK</button>
                            <button type="button" class="btn default" v-on:click="cancelarExportacaoExcel">Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="exportDialog.visible" class="modal-backdrop fade in"></div>
        </div>
    </div>
</template>

<script>    
var DevExpress = require("devextreme/bundles/modules/core");
var dx = (DevExpress.ui = require("devextreme/bundles/modules/ui"));
require("devextreme/integration/jquery");
// require("devextreme-intl");
const localization = require('devextreme/localization');
localization.locale("pt-BR");

// DevExpress.config({ defaultCurrency: 'BRL' })
import config from "devextreme/core/config";
 
config({
    defaultCurrency: 'BRL'
});

require("devextreme/ui/pivot_grid");
require("devextreme/viz/chart");
import { mapGetters } from 'vuex';

import ExcelJS from 'exceljs';
import { exportPivotGrid } from 'devextreme/excel_exporter';
import pako from 'pako';

export default {
    props: ['title'],
    data() {
        return {
            data: null,
            fields: [],
            pivotGrid: null,
            fieldPanelVisible: true,
            fieldPanelShowColumnFields: true,
            fieldPanelShowDataFields: true,
            fieldPanelShowFilterFields: true,
            showCheckBox: true,
            exportDialog: {
                visible: false,
                component: null,
                empresa: "",
                abaAtiva: "formatacao",
                parametros: {}
            }
        };
    },
    computed: {
        ...mapGetters({ isFieldChecked: 'filtro/isFieldChecked' }),
        nomeArquivoBalancetePreview: function () {
            return this.resolverNomeArquivoBalancete(this.exportDialog.parametros.ExpressaoNomeArquivo, this.exportDialog.parametros.FormatoSaida);
        }
    },
    mounted: function () {
        let vm = this;
        this.$store.subscribe((mutation, state) => {
            if (mutation.type == 'pivotgrid/beginRequest') {
                vm.beginRequest();
            }
            else if (mutation.type == 'pivotgrid/endRequestSuccess') {
                vm.loadData(state.pivotgrid.dataset);
            }
            else if (mutation.type == 'pivotgrid/endRequestError') {
                vm.endRequestError(state.pivotgrid.error);
            }
        });
    },
    methods: {
        getDefaultFields: function () {
            return [{ "groupName": "ContaContabil", "area": "row" },
            { "caption": "Contas", "dataField": "conta1", "visible": true, "groupName": "ContaContabil", "groupIndex": 0 }, 
            { "caption": "2", "dataField": "conta2", "visible": false, "groupName": "ContaContabil", "groupIndex": 1 }, 
            { "caption": "3", "dataField": "conta3", "visible": false, "groupName": "ContaContabil", "groupIndex": 2 }, 
            { "caption": "4", "dataField": "conta4", "visible": false, "groupName": "ContaContabil", "groupIndex": 3 }, 
            { "caption": "5", "dataField": "conta5", "visible": false, "groupName": "ContaContabil", "groupIndex": 4 },
            { "dataField": "date", "dataType": "date", "area": "column", "groupName": "Date" }, 
            { "groupName": "Date", "caption": "Ano", "groupInterval": "year", "groupIndex": "0" },
            { "groupName": "Date", "caption": "Mês", "groupInterval": "month", "groupIndex": "1" },
            { "dataField": "saldoAnterior", "summaryType": "sum", "caption": "Saldo anterior", "format": { "type": "currency", "precision": 2, "currency": "BRL" }, "area": "data", "calculateSummaryValue": "function(e) { if (e.field('column') == null) { return e.value(); } else { return null; } }" }, { "dataField": "debito", "caption": "Débitos", "area": "data", "dataType": "number", "format": { "type": "currency", "precision": 2, "currency": "BRL" }, "summaryType": "sum", "disableContext": true }, { "dataField": "credito", "caption": "Créditos", "area": "data", "dataType": "number", "format": { "type": "currency", "precision": 2, "currency": "BRL" }, "summaryType": "sum", "disableContext": true }, { "dataField": "saldoAtual", "summaryType": "sum", "caption": "Saldo anterior", "format": { "type": "currency", "precision": 2, "currency": "BRL" }, "area": "data", "calculateSummaryValue": "function(e) { if (e.field('column') == null) { return e.value(); } else { return null; } }" }]
        },
        beginRequest: function () {
            this.clearMessagePanel();
            window.App.blockUI({
                target: this.$el,
                message: '<h3>Buscando dados...</h3>',
            });
        },
        getMessagePanel() {
            return this.$store.state.pivotgrid.messagePanel;
        },
        setMessagePanel(mensagem) {
            this.$store.commit('pivotgrid/setMessagePanel', mensagem);
        },
        clearMessagePanel() {
            this.$store.commit('pivotgrid/clearMessagePanel');
        },
        endRequestError: function (error) {
            window.App.unblockUI(this.$el);
            this.setMessagePanel({ type: "danger", message: error, title: "" });
            this.renderPivot();
        },
        loadData: function (dataset) {
           
            window.App.unblockUI(this.$el);

            if (dataset.avisosGeracao)
                this.setMessagePanel({ type: "info", message: dataset.avisosGeracao, title: "Advertência" });
            else
                this.clearMessagePanel();          

            // DEBUG
            // this.fields = this.getDefaultFields();                
            // dataset.store; são os dados oriundos do backend
            // this.data = dataset;
            // alert("Campos recebidos:\n\n" + dataset.fields.map(f => f.dataField).join("\n"));
            // console.log(dataset.store[0]);

            // PROD
            this.fields = dataset.fields;
            this.data = dataset.store;

            sessionStorage.setItem('nivelConta', dataset.nivelEstrutura);

            /* MANTER COMENTADO PORQUE ESSA GAMBI É FEITA NO BACKEND, DE FORMA MAIS BELA
            if (data != null && data.length > 0) {                    
                this.groupData('conta', 'Conta', 'niveisConta');
                this.groupData('centroCusto', 'Centro de custo', 'niveisCentroCusto');
                this.groupData('projeto', 'Projeto', 'niveisProjeto');
            }*/

            this.renderPivot();

            jQuery('.dx-pivotgrid-toolbar').append(
                // espaçamento - inicio
                '<div class="dx-pivotgrid-export-button dx-button dx-button-normal dx-widget dx-button-has-icon"></div>' +
                '<div class="dx-pivotgrid-export-button dx-button dx-button-normal dx-widget dx-button-has-icon"></div>' +
                '<div class="dx-pivotgrid-export-button dx-button dx-button-normal dx-widget dx-button-has-icon"></div>' +
                // espaçamento - fim
                '<div class="dx-pivotgrid-export-button dx-button dx-button-normal dx-widget dx-button-has-icon">' +
                '<span>Nível:  </span>' +
                '<div class="dx-pivotgrid-export-button dx-button dx-button-normal dx-widget dx-button-has-icon">' +
                '<button type="button" title="Expandir nível" style="font-size:20px;background-color: #f8f8f8;border:none;" onclick="ExpandConta()"><i class="fa fa-plus-circle"></i></button>' +
                '</div>' +
                '<div class="dx-pivotgrid-export-button dx-button dx-button-normal dx-widget dx-button-has-icon">' +
                '<button type="button" title="Recolher nível" style="font-size:20px;background-color: #f8f8f8;border:none;" onclick="CollapseConta()"><i class="fa fa-minus-circle"></i></button>' +
                '</div>' +
                '</div>');
        },
        checkClick: function (field) {
            //console.log("checkclick");
            this.pivotGrid.getDataSource().field(field.dataField, { visible: !field.visible });
            this.pivotGrid.getDataSource().reload();
        },
        tituloTipoBalancete: function () {
            return this.$store.state.filtro.abertura ? "BALANCETE DE ABERTURA" : "BALANCETE";
        },
        periodoReferenciaBalancete: function () {
            var inicio = moment(this.$store.state.options.startDate, 'DD/MM/YYYY');
            var fim = moment(this.$store.state.options.endDate, 'DD/MM/YYYY');
            if (!inicio.isValid() || !fim.isValid()) return '';
            if (inicio.isSame(fim, 'day')) return inicio.format('DD/MM/YYYY');
            return inicio.format('DD/MM/YYYY') + ' a ' + fim.format('DD/MM/YYYY');
        },
        localizarNoTreeviewBalancete: function (raiz, id) {
            if (!Array.isArray(raiz)) return '';
            for (var i = 0; i < raiz.length; i++) {
                var item = raiz[i] || {};
                if (String(item.id || item.key || item.handle) === id)
                    return item.text || item.nome || item.name || item.title || '';
                var encontrado = this.localizarNoTreeviewBalancete(item.children || item.items, id);
                if (encontrado) return encontrado;
            }
            return '';
        },
        nomeFilialSelecionadaBalancete: function () {
            var selecao = this.$store.state.treeview && this.$store.state.treeview.treeview_selecoes
                ? this.$store.state.treeview.treeview_selecoes.filter(function (x) { return x.id === 'empresaFilial'; })[0]
                : null;
            if (!selecao || !selecao.selected || !selecao.selected.length) return '';
            var partes = String(selecao.selected[0]).split('-');
            if (partes.length < 2) return '';
            var raiz = selecao.data && (selecao.data.items || selecao.data);
            return this.localizarNoTreeviewBalancete(raiz, partes[1]);
        },
        cabecalhoEsquerdaPadraoBalancete: function () {
            var empresaFilial = [this.nomeEmpresaSelecionadaBalancete(), this.nomeFilialSelecionadaBalancete()]
                .filter(Boolean).join(' - ');
            var periodo = this.periodoReferenciaBalancete();
            var titulo = this.tituloTipoBalancete() + (periodo ? ' Ref. ' + periodo : '');
            return empresaFilial ? empresaFilial + ' - ' + titulo : titulo;
        },
        rodapeEsquerdaPadraoBalancete: function () {
            var partes = [];
            if (this.$store.state.filtro.fechamentoGerencial)
                partes.push('Fechamentos gerenciais');
            if (this.$store.state.filtro.antesZeramento && this.$store.state.filtro.ignorarPosteriorDate)
                partes.push('Ignorar zeramentos após ' + this.$store.state.filtro.ignorarPosteriorDate);
            return partes.join(' - ');
        },
        criarParametrosExportacaoPadrao: function () {
            return {
                CabecalhoAdicional: "",
                AssinaturaEsquerda: "",
                AssinaturaDireita: "",
                EspacamentoAssinaturas: 10,
                CabecalhoEsquerda: this.cabecalhoEsquerdaPadraoBalancete(),
                CabecalhoCentro: "",
                CabecalhoDireita: "&D &T - Pág.: &P",
                RodapeEsquerda: this.rodapeEsquerdaPadraoBalancete(),
                RodapeCentro: "",
                RodapeDireita: "",
                CentralizarHorizontalmente: false,
                CentralizarVerticalmente: false,
                MargemEsquerda: 0.5,
                MargemTopo: 1,
                MargemDireita: 0.5,
                MargemFundo: 1,
                ReduzirPaginasHorizontais: -1,
                ReduzirPaginasVerticais: -1,
                DaEsquerdaParaDireita: false,
                IgnorarCores: true,
                LinhasDeGrade: false,
                Paisagem: true
                ,ExpressaoNomeArquivo: "balancete_{EMPRESA}_{PERIODO}.xlsx",
                FormatoSaida: "XLSX"
            };
        },
        abrirDialogoExportacaoExcel: function (component) {
            this.exportDialog.component = component;
            this.exportDialog.parametros = this.criarParametrosExportacaoPadrao();
            this.exportDialog.abaAtiva = "formatacao";
            this.exportDialog.visible = true;

            var vm = this;
            $.ajax({
                type: "GET",
                url: Benner.Page.getApplicationPath() + 'ConsultasContabil/ObterPreferenciasExportacaoBalancete'
            }).done(function (preferencias) {
                if (preferencias)
                    vm.exportDialog.parametros = Object.assign(vm.criarParametrosExportacaoPadrao(), preferencias);
            });
            $.get(Benner.Page.getApplicationPath() + 'ConsultasContabil/ObterMetadadosArquivoBalancete')
                .done(function (metadados) { vm.exportDialog.empresa = metadados ? metadados.Empresa : ''; });
        },
        definirParametrosExportacaoPadrao: function () {
            this.exportDialog.parametros = this.criarParametrosExportacaoPadrao();
            this.salvarPreferenciasExportacaoBalancete(this.exportDialog.parametros);
        },
        salvarPreferenciasExportacaoBalancete: function (parametros) {
            $.ajax({
                type: "POST",
                url: Benner.Page.getApplicationPath() + 'ConsultasContabil/SalvarPreferenciasExportacaoBalancete',
                data: JSON.stringify(parametros),
                contentType: "application/json; charset=utf-8"
            });
        },
        ajustarBotaoExportacao: function () {
            this.$nextTick(function () {
                var botao = $(this.$el)
                    .find("#pivotgrid .dx-icon-exportxlsx")
                    .closest(".dx-button");
                var icone = botao.find(".dx-icon-exportxlsx");

                botao
                    .addClass("balancete-export-button")
                    .attr("title", "Exportar")
                    .attr("aria-label", "Exportar");

                icone
                    .removeClass("dx-icon dx-icon-exportxlsx")
                    .addClass("fa fa-download balancete-export-icon");

                botao.find(".dx-button-text").text("Exportar");
            });
        },
        alterarFormatoSaida: function (formatoSaida) {
            this.$set(this.exportDialog.parametros, 'FormatoSaida', formatoSaida);

            var expressao = this.exportDialog.parametros.ExpressaoNomeArquivo || 'balancete_{EMPRESA}_{PERIODO}.xlsx';
            var extensao = formatoSaida === 'PDF' ? '.pdf' : '.xlsx';

            if (/\.(xlsx|pdf)$/i.test(expressao))
                expressao = expressao.replace(/\.(xlsx|pdf)$/i, extensao);
            else
                expressao += extensao;

            this.$set(this.exportDialog.parametros, 'ExpressaoNomeArquivo', expressao);
        },
        cancelarExportacaoExcel: function () {
            this.exportDialog.visible = false;
            this.exportDialog.component = null;
        },
        confirmarExportacaoExcel: function () {
            var component = this.exportDialog.component;
            var parametros = Object.assign({}, this.exportDialog.parametros);
            parametros.NomeArquivo = this.resolverNomeArquivoBalancete(parametros.ExpressaoNomeArquivo, parametros.FormatoSaida);

            this.exportDialog.visible = false;
            this.exportDialog.component = null;

            if (component)
                this.exportarArquivo(component, parametros);
        },
        inserirTokenNomeArquivo: function (token) {
            var atual = this.exportDialog.parametros.ExpressaoNomeArquivo || "";
            this.$set(this.exportDialog.parametros, 'ExpressaoNomeArquivo', atual + token);
        },
        normalizarParteNomeArquivo: function (valor) {
            return (valor || '').toString().trim().replace(/[\\/:*?"<>|]/g, '-').replace(/\s+/g, '_');
        },
        periodoNomeArquivoBalancete: function () {
            var inicio = moment(this.$store.state.options.startDate, 'DD/MM/YYYY');
            var fim = moment(this.$store.state.options.endDate, 'DD/MM/YYYY');
            if (!inicio.isValid() || !fim.isValid()) return '';
            var a = inicio.format('MM-YYYY');
            var b = fim.format('MM-YYYY');
            return a === b ? a : a + '_' + b;
        },
        resolverNomeArquivoBalancete: function (expressao, formatoSaida) {
            var nome = expressao || 'balancete_{EMPRESA}_{PERIODO}.xlsx';
            nome = nome.replace(/\{EMPRESA\}/gi, this.normalizarParteNomeArquivo(this.nomeEmpresaSelecionadaBalancete() || this.exportDialog.empresa || 'Empresa'));
            nome = nome.replace(/\{PERIODO\}/gi, this.periodoNomeArquivoBalancete());
            nome = nome.replace(/\{PERFIL_BALANCETE\}/gi, this.normalizarParteNomeArquivo(this.$store.state.filtro.nomePerfil || 'Perfil'));
            nome = nome.replace(/[\\/:*?"<>|]/g, '-').replace(/\.+$/g, '');

            var LIMITE_NOME_ARQUIVO = 100;
            if (nome.length > LIMITE_NOME_ARQUIVO)
                nome = nome.substring(0, LIMITE_NOME_ARQUIVO);

            var extensao = (formatoSaida || 'XLSX').toUpperCase() === 'PDF' ? '.pdf' : '.xlsx';
            nome = nome.replace(/\.(xlsx|pdf)$/i, '');
            nome += extensao;
            return nome;
        },
        nomeEmpresaSelecionadaBalancete: function () {
            var selecao = this.$store.state.treeview && this.$store.state.treeview.treeview_selecoes
                ? this.$store.state.treeview.treeview_selecoes.filter(function (x) { return x.id === 'empresaFilial'; })[0]
                : null;
            if (!selecao || !selecao.selected || !selecao.selected.length) return '';
            var idEmpresa = String(selecao.selected[0]).split('-')[0];
            var raiz = selecao.data && (selecao.data.items || selecao.data);
            function localizar(itens) {
                if (!Array.isArray(itens)) return '';
                for (var i = 0; i < itens.length; i++) {
                    var item = itens[i] || {};
                    if (String(item.id || item.key || item.handle) === idEmpresa)
                        return item.text || item.nome || item.name || item.title || '';
                    var encontrado = localizar(item.children || item.items);
                    if (encontrado) return encontrado;
                }
                return '';
            }
            return localizar(raiz);
        },
        exportarArquivo: function (component, parametrosExportacao) {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Main sheet');
            const request = [];

            exportPivotGrid({
                component: component,
                worksheet: worksheet,
                customizeCell: function (options) {
                    const { excelCell, pivotCell } = options;

                    request.push({
                        Linha: excelCell.row,
                        LetraColuna: excelCell.address.charAt(0),
                        Texto: excelCell.text,
                        isLast: pivotCell.isLast,
                        Tipo: pivotCell.type,
                        FormatarMilhar: app.$store.getters["filtro/isValoresEmMilhares"],
                        MostrarApelido: app.$store.getters["filtro/isMostrarApelido"],
                        MostrarReduzido: app.$store.getters["filtro/isMostrarReduzido"]
                    });
                }
            }).then(function () {
                var formatoPdf = (parametrosExportacao.FormatoSaida || '').toUpperCase() === 'PDF';
                toastr.info("Exportar balancete contábil.", formatoPdf ? "Exportar PDF" : "Exportar excel");

                function groupRequestsByLinha(requests) {
                    const groupedRequests = {};

                    requests.forEach(request => {
                        if (!groupedRequests[request.Linha]) {
                            groupedRequests[request.Linha] = {
                                Linha: request.Linha,
                                MostrarApelido: request.MostrarApelido,
                                MostrarReduzido: request.MostrarReduzido,
                                Colunas: []
                            };
                        }

                        groupedRequests[request.Linha].Colunas.push({
                            Estrura: '',
                            LetraColuna: request.LetraColuna,
                            Texto: request.Texto,
                            isLast: request.isLast,
                            Tipo: request.Tipo,
                            LinhaOriginal: request.Linha,
                            FormatarMilhar: request.FormatarMilhar,
                        });
                    });

                    return Object.values(groupedRequests);
                }

                const formattedRequests = groupRequestsByLinha(request);
                if (formattedRequests.length > 0)
                    formattedRequests[0].ParametrosExportacao = parametrosExportacao;

                const compressedRequests = pako.gzip(JSON.stringify(formattedRequests));
                const base64CompressedRequests = arrayBufferToBase64(compressedRequests);

                function arrayBufferToBase64(buffer) {
                    let binary = '';
                    const bytes = new Uint8Array(buffer);
                    const len = bytes.byteLength;
                    for (let i = 0; i < len; i++) {
                        binary += String.fromCharCode(bytes[i]);
                    }
                    return btoa(binary);
                }

                $.ajax({
                    type: "POST",
                    url: Benner.Page.getApplicationPath() + (formatoPdf ? 'ConsultasContabil/ExportarBalancetePdf' : 'ConsultasContabil/ExportarBalanceteExcel'),
                    data: base64CompressedRequests,
                    contentType: "text/plain"
                }).done(function (data) {
                    Benner.AsyncProcesses.initAjax();
                });
            });
        },
        renderPivot: function () {

            var vm = this;

            this.pivotGrid = null;
            this.pivotGrid = $("#pivotgrid").dxPivotGrid({
                allowSortingBySummary: true,
                allowExpandAll: true,
                height: 750,
                allowFiltering: true,
                showBorders: false,
                showColumnGrandTotals: false,
                showRowGrandTotals: false,
                showRowTotals: false,
                showTotalsPrior: false,
                showColumnTotals: false,
                wordWrapEnabled: false,
                rowHeaderLayout: "tree",
                fieldChooser: {
                    allowSearch: true
                },
                scrolling: {
                    mode: "virtual"
                },
                fieldPanel: {
                    allowFieldDragging: true,
                    showColumnFields: this.fieldPanelShowColumnFields,
                    showDataFields: this.fieldPanelShowDataFields,
                    showFilterFields: this.fieldPanelShowFilterFields,
                    showRowFields: true,
                    visible: this.fieldPanelVisible,
                    texts: {
                        rowFieldArea: "Arraste os campos de linha aqui",
                        filterFieldArea: "Arraste os campos de filtro aqui",
                        dataFieldArea: "Arraste os campos de valor aqui",
                        columnFieldArea: "Arraste os campos de coluna aqui"
                    }
                },
                texts: {
                    noData: "Nenhum dado encontrado",
                    collapseAll: "Recolher todos - deste nível",
                    expandAll: "Expandir todos - deste nível",
                    sortRowBySummary: "Ordenar por {0}",
                    removeAllSorting: "Limpar ordenação",
                    sortColumnBySummary: "Ordenar por {0}",
                    showFieldChooser: "Escolher campo",
                    exportToExcel: "Exportar",
                    grandTotal: "Totais"
                },
                "export": {
                    enabled: true,
                    fileName: "BalanceteContabil",
                },
                onCellClick: function(e) {
                    // Código para mostrar o analítico no aspx pois é mais rápido de desenvolver
                    ShowAnalitico(e);                                
                },
                onContentReady: function () {
                    vm.ajustarBotaoExportacao();
                },
                onExporting: function (e) {
                    vm.abrirDialogoExportacaoExcel(e.component);
                    e.cancel = true;
                },
                onCellPrepared: function (e) {

                    if (!e.cell || !e.cell.text)
                        return;                    

                    // Formatação condicional de texto
                    if (e.area == 'data') {
                        var ehValorNegativo = Number(e.cell.text.replace(/[^0-9-]+/g, "")) < 0;
                        var nomeColuna = $("#pivotgrid").dxPivotGrid("instance").getDataSource().getAreaFields("data", true)[e.cell.dataIndex].dataField;
                        e.cellElement.addClass((ehValorNegativo || nomeColuna == "credito" ? 'font-red' : 'font-blue') + ' analitico');
                        e.cellElement.empty();
                        // chama o método que está na página(aspx)
                        e.cellElement.append($("<span />").text(FormatarValorCelula(
                            e.cell.text.toString(),
                            ehValorNegativo ? "C" : "D",
                            nomeColuna)));
                    }

                    // Esconder linhas com a expressão "CC não informado" e "Projeto não informado"
                    try {
                        if (e.area !== "row" || !e.cell) return;

                        const path = e.cell.path;
                        if (!Array.isArray(path) || path.length === 0) return;

                        const ds = e.component.getDataSource();
                        const last = path[path.length - 1];

                        // --- utils (ES5) ---
                        function norm(s) {
                        if (s === undefined || s === null) s = "";
                        return String(s).replace(/^~\s*/,"").trim().toLowerCase();
                        }
                        function stripTotalEnd(s) {
                        return String(s).replace(/\s+total\s*$/i, "");
                        }
                        function isNotInfLabel(label) {
                        var n = stripTotalEnd(norm(label));
                        return n === "cc não informado" || n === "projeto não informado";
                        }

                        // compara item do tree com valor do path (aceita key/value/text)
                        function matchesNodeItem(item, pathValue) {
                        var pv = String(pathValue);
                        // key/value podem ser números; compare como string
                        if (item.key !== undefined && String(item.key) === pv) return true;
                        if (item.value !== undefined && String(item.value) === pv) return true;
                        if (item.text !== undefined && String(item.text) === pv) return true;
                        // fallback: último pedaço do texto do path do item
                        if (item.path && item.path.length) {
                            var last = String(item.path[item.path.length - 1]);
                            if (last === pv) return true;
                        }
                        return false;
                        }

                        // localiza o nó a partir do path visível
                        function getNodeByPath(ds, p) {
                        var data = ds.getData();
                        var level = data ? data.rows : null;
                        var node = null;
                        for (var i = 0; level && i < p.length; i++) {
                            var key = p[i], found = null;
                            for (var j = 0; j < level.length; j++) {
                            var it = level[j];
                            if (matchesNodeItem(it, key)) { found = it; break; }
                            }
                            if (!found) return null;
                            node = found;
                            level = (found.children || found.items || []);
                        }
                        return node;
                        }

                        // devolve o rótulo visível de um filho (path/text)
                        function childLabel(item) {
                        if (item.path && item.path.length)
                            return String(item.path[item.path.length - 1]);
                        if (item.text !== undefined)
                            return String(item.text);
                        if (item.value !== undefined)
                            return String(item.value);
                        return "";
                        }

                        // ✅ só retorna true se CONSIGO ver filhos e TODOS forem "não informado"
                        function allChildrenAreNotInf(node) {
                        var kids = node ? (node.children || node.items || []) : [];
                        if (!kids.length) return false; // sem filhos materializados -> não colapsa
                        for (var i = 0; i < kids.length; i++) {
                            var lbl = childLabel(kids[i]);
                            if (!isNotInfLabel(lbl)) return false;
                        }
                        return true;
                        }

                        // (1) Só colapsa o PAI se TODOS os filhos diretos forem "CC não informado" / "Projeto não informado" (com ou sem "Total")
                        if (path.length > 1 && isNotInfLabel(last)) {
                        var parentPath = path.slice(0, -1);
                        var parentNode = getNodeByPath(ds, parentPath);

                        // só colapsa se CONSEGUI ver todos os filhos e todos forem "não informado"
                        if (allChildrenAreNotInf(parentNode)) {
                            ds.collapseHeaderItem("row", parentPath);
                        }
                        return;
                        }
                        
                        // --- 2) Colapsar linhas-resumo de 1º nível ("~ Ativo/Passivo/Resultado/Total Total")
                        if (path.length === 1) {
                        // aceita variantes: "~ Ativo", "~ Ativo Total", com espaços; case-insensitive
                        const isResumoTopLevel = /^~\s*(Ativo|Passivo|Resultado|Total)(\s+Total)?$/i.test(last);
                        if (isResumoTopLevel) {
                            ds.collapseHeaderItem("row", path.slice()); // colapsa o próprio item de 1º nível
                        }
                        }
                    } catch (err) {
                        console.error("❌ Erro ao colapsar:", err);
                    }
                },
                dataSource: {
                    retrieveFields: false,
                    fields: this.fields,
                    store: this.data
                }
            }).dxPivotGrid("instance");
        },
        obterAgrupadorConformePeriodoSelecionado() {
            if (this.isFieldChecked("saldoDiario"))
                return this.agrupadorDiario;
            if (this.$store.getters["filtro/isPeriodoMeses"])
                return this.agrupadorPorMeses;
            if (this.$store.getters["filtro/isPeriodoTrimestres"])
                return this.agrupadorPorTrimestre;
            if (this.$store.getters["filtro/isPeriodoSemestres"])
                return this.agrupadorPorSemestre;
            if (this.$store.getters["filtro/isPeriodoAnos"])
                return this.agrupadorPorAno;
        },
        agrupadorDiario(data) {
            return moment(data.date).format("DD/MM/YYYY");
        },
        agrupadorPorMeses(data) {
            return moment(data.date).format("MMM/YYYY");
        },
        agrupadorPorTrimestre(data) {
            return String.format("Trimestre {0}", moment(data.date).format("Q/YYYY"));
        },
        agrupadorPorSemestre(data) {
            var mes = moment(data.date).month();
            var semestre = (mes > 5 ? 2 : 1);
            return String.format("Semestre {0}/{1}", semestre, moment(data.date).format("YYYY"));
        },
        agrupadorPorAno(data) {
            return moment(data.date).format("YYYY");
        }
    },
    watch: {
        fields(value) {
            var indexCampoData = value.findIndex(campo => campo.dataField == "date");

            if (indexCampoData > -1) {
                this.fields[indexCampoData].selector = this.obterAgrupadorConformePeriodoSelecionado();
                this.fields[indexCampoData].sortingMethod = function (a, b) {
                    if (a.text == b.text)
                        return 0;

                    if (a.index > b.index)
                        return 1;
                    else
                        return -1;
                };
            }
        }
    }
};

</script>

<style scoped>
.balancete-export-dialog .modal-dialog {
    width: 760px;
}

.balancete-export-dialog fieldset {
    border: 1px solid #d7d7d7;
    padding: 10px 12px 6px 12px;
    margin-bottom: 12px;
}

.balancete-export-dialog legend {
    width: auto;
    border: 0;
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 6px;
    padding: 0 4px;
}

.balancete-export-dialog .form-group {
    margin-bottom: 8px;
}

.balancete-export-dialog label {
    font-weight: normal;
}

.balancete-export-dialog .balancete-export-tabs {
    margin-bottom: 12px;
}

.balancete-export-dialog .balancete-export-tab-content {
    min-height: 390px;
}

.balancete-export-dialog .balancete-export-options .checkbox-inline {
    display: block;
    margin-left: 0;
}

/deep/ .balancete-export-button .balancete-export-icon {
    font-size: 14px;
    line-height: 1;
}

/deep/ #pivotgrid .dx-icon-xlsxfile:before {
    content: "\f019";
    font-family: FontAwesome;
}
</style>
